import {
  FilterType,
  buildEmployeePulseEmployeeDatatableFilter,
  useEmployeePulseEmployeeDatatable,
} from 'generated/resources/datatable.graphql'
import { SignalsTag } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const topicFilter = (
  source: ReturnType<typeof useEmployeePulseEmployeeDatatable>,
  tags: Pick<SignalsTag, 'id' | 'name'>[]
) => {
  const options = tags.map(({ name, id }) => ({ label: name, value: id }))
  options.unshift({
    label: i18n.t('engagement.pulse.dashboard.datatable.filters.no_data'),
    value: 'no_data',
  })

  return buildEmployeePulseEmployeeDatatableFilter(source, {
    title: i18n.t('engagement.pulse.dashboard.datatable.filters.topic'),
    path: 'tag',
    identifier: 'tags',
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: options,
      },
    ],
  })
}

export default topicFilter
